import React from 'react';
import { Redirect } from 'react-router-dom';
import { useAuth } from './common/Auth';
import Footer from './common/Footer';
import logo from './simulcastlogo.svg';
import BigLogo from './img/biglogo.svg';

const Landing = () => {
	const currentUser = useAuth();
	if (currentUser) {
		return <Redirect to="/app" />;
	}
	return (
		<div className="bg-gray-950 text-white">
			<div 
				className="min-h-[90vh] flex flex-col items-center justify-center bg-center bg-cover relative" 
				style={{backgroundImage: `url(${BigLogo})`, backgroundSize: 'cover', backgroundPosition: 'center'}}
			>
				<div className="absolute inset-0 bg-black/40"></div>
				<div className="relative z-10 text-center px-6">
					<img 
						src={logo} 
						className="mx-auto w-2/3 max-w-[380px] mb-8" 
						style={{maxWidth: '380px', width: '66%', height: 'auto'}}
						alt="Simulcast" 
					/>
					<h1 className="text-3xl md:text-4xl lg:text-5xl font-semibold tracking-tighter mb-4">
						Lighting control at scale
					</h1>
					<p className="text-lg md:text-xl text-white/90 mb-4 max-w-2xl mx-auto leading-relaxed">
						Design scenes, automate schedules, and synchronize colorful lighting across a single
						building, an entire city, or installations nationwide — all from your browser.
					</p>
					<p className="text-sm md:text-base text-white/65 mb-8 max-w-xl mx-auto leading-relaxed">
						Link multiple gateways into one cohesive system. Fire looks on a fixed clock, a repeating
						rule, or at sunset. Let Jules suggest event-themed colors when you need them.
					</p>
					<div className="flex flex-col sm:flex-row gap-3 justify-center">
						<a href="/login" className="inline-block px-8 py-3 bg-white text-[#880e4f] font-semibold rounded-xl hover:bg-gray-100 transition-colors">Log in</a>
						<a href="/signup" className="inline-block px-8 py-3 border border-white/70 hover:bg-white/10 font-medium rounded-xl transition-colors">Create account</a>
					</div>
					<div className="mt-4">
						<a href="/docs" className="inline-block px-6 py-2.5 text-sm text-white/90 border border-white/30 hover:bg-white/10 rounded-xl transition-colors">
							Documentation
						</a>
					</div>
				</div>
			</div>
			<Footer />
		</div>
	);
}

export default Landing;